/** Which download page a member sees. */
export type DownloadVersion = 'default' | 'rewards';

export interface DownloadVersionInput {
  /** The sponsor's rewards flag; false when the sponsor read failed. */
  rewards: boolean;
  /** Whether the member chose chat over a welcome call in this visit. */
  chatChosen: boolean;
}

/**
 * The rewards version is for members whose employer has rewards and who chose
 * chat: they skipped the welcome call, so the page reminds them it earns
 * points. Everyone else sees the default page.
 */
export function downloadVersion({ rewards, chatChosen }: DownloadVersionInput): DownloadVersion {
  return rewards && chatChosen ? 'rewards' : 'default';
}
